import React from "react";

import Button from "../common/Button";

const GetADemoButton: React.FunctionComponent = () => (
  <Button color="primary" className="get-a-demo button-wide-mobile">
    Get a demo
  </Button>
);

export default GetADemoButton;
